// extracted by mini-css-extract-plugin
export default {"close-button":"ujvZ4C","closeButton":"ujvZ4C","closeButtonImage":"hozQG9","dark":"PyynXE"};